import React from 'react';
import {useTranslation} from 'react-i18next';

export default function EmptyResultMessage() {
    const [t] = useTranslation();

    return (
        <div className="alert alert-info">
            {t('Table.NO_RESULT')}
        </div>
    );
}
